import * as actionTypes from './actionTypes'
import { fromJS } from 'immutable'


export const getHeaderData = (data) => ({
    type:actionTypes.GET_HEADER_DATA,
    data
})
export const setHeaderData = data => ({
    type:actionTypes.SET_HEADER_DATA,
    data:fromJS(data)
})